import React from 'react';

export const StepCard = ({ icon: Icon, step, title, desc }) => (
  <div className="relative bg-white p-8 rounded-[40px] border border-gray-100 shadow-sm hover:shadow-xl transition-all group">
    <span className="absolute top-6 right-8 text-4xl font-black text-blue-200 group-hover:text-blue-300 transition-colors uppercase">
      {step}
    </span>
    <div className="bg-blue-100 p-5 rounded-3xl w-fit text-blue-600 mb-6 group-hover:bg-blue-600 group-hover:text-white transition-all duration-500">
      <Icon size={28} />
    </div>
    <h4 className="text-xl font-black text-gray-900 mb-3">{title}</h4>
    <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
  </div>
);
